"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const equationTypePredicates_1 = require("./equationTypePredicates");
const walkEquation_1 = require("./walkEquation");
exports.findSlots = (logicTree) => {
    const slots = [];
    walkEquation_1.walkEquation(logicTree, element => {
        if (equationTypePredicates_1.isEquationSlot(element)) {
            slots.push(element);
        }
    });
    return slots;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmluZFNsb3RzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2V2YWx1YXRvci9lcXVhdGlvbi9maW5kU2xvdHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFDQSxxRUFBMEQ7QUFDMUQsaURBQThDO0FBRWpDLFFBQUEsU0FBUyxHQUFHLENBQUMsU0FBbUIsRUFBRSxFQUFFO0lBQy9DLE1BQU0sS0FBSyxHQUFtQixFQUFFLENBQUM7SUFDakMsMkJBQVksQ0FBQyxTQUFTLEVBQUUsT0FBTyxDQUFDLEVBQUU7UUFDaEMsSUFBSSx1Q0FBYyxDQUFDLE9BQU8sQ0FBQyxFQUFFO1lBQzNCLEtBQUssQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLENBQUM7U0FDckI7SUFDSCxDQUFDLENBQUMsQ0FBQztJQUNILE9BQU8sS0FBSyxDQUFDO0FBQ2YsQ0FBQyxDQUFDIn0=